import API from "./API";

export default class Role extends API
{
    static async all() {
        return this.get("api/admin/permissions/list");
    }
}